import FetchUtil from "../util/FetchUtil";
import ConfigUtil from "../util/ConfigUtil";

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const REQUEST_LOGIN_BY_TOKEN = 'REQUEST_LOGIN_BY_TOKEN';
export const LOGIN_BY_TOKEN_SUCCESSFUL = 'LOGIN_BY_TOKEN_SUCCESSFUL';
export const LOGIN_BY_TOKEN_FAILED = 'LOGIN_BY_TOKEN_FAILED';
export const AUTODARTS_BOARDID_SAVE = 'AUTODARTS_BOARDID_SAVE';

export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const LOGOUT_SUCCESSFUL = 'LOGOUT_SUCCESSFUL';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';
// Login abgelaufen (Antwort 401), das Backend hat das Cookie bereits gelöscht, daher kein Aufruf von /logout
export const SESSION_ABGELAUFEN = 'SESSION_ABGELAUFEN';
export const SET_EVENT_OPERATOR = 'SET_EVENT_OPERATOR';

export const REQUEST_SIGNUP = 'REQUEST_SIGNUP';
export const SIGNUP_SUCCESSFUL = 'SIGNUP_SUCCESSFUL';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';

export const requestLogin = () => ({
    type: REQUEST_LOGIN
});
export const sessionAbgelaufen = () => ({
    type: SESSION_ABGELAUFEN
});
export const loginSuccessful = () => ({
    type: LOGIN_SUCCESSFUL
});
export const loginFailed = (message) => ({
    type: LOGIN_FAILED,
    message
});
export const requestLoginByToken = () => ({
    type: REQUEST_LOGIN_BY_TOKEN
});
export const loginByTokenSuccessful = (userInfo) => ({
    type: LOGIN_BY_TOKEN_SUCCESSFUL,
    userInfo
});
export const saveAutodartsBoardId = (boardId) => ({
    type: AUTODARTS_BOARDID_SAVE,
    boardId
});
export const loginByTokenFailed = () => ({
    type: LOGIN_BY_TOKEN_FAILED
});
export const requestLogout = () => ({
    type: REQUEST_LOGOUT
});
export const logoutSuccessful = () => ({
    type: LOGOUT_SUCCESSFUL
});
export const logoutFailed = () => ({
    type: LOGOUT_FAILED
});
export const setAsEventOperator = () => ({
    type: SET_EVENT_OPERATOR
});

export function login(name, password, afterLoginCallback, errorCallback) {
    return function (dispatch) {
        dispatch(requestLogin());
        return FetchUtil.fetchPost(ConfigUtil.getConfig().loginUrl,
            {name, password},
            json => {
                dispatch(loginSuccessful());
                dispatch(loginByToken());
                afterLoginCallback();
            },
            responseNotOk => {
                console.log(responseNotOk);
                dispatch(loginFailed(responseNotOk.message));
                errorCallback("Fehler beim Login! Evtl. Zugangdaten falsch oder inaktiver Account! Tipp: Du musst deinen Benutzernamen und nicht deine Emailadresse nutzen. Achte bitte auf die Groß- und Kleinschreibung.")
            },
            error => {
                errorCallback("Fehler beim Login! Evtl. Zugangdaten falsch oder inaktiver Account! Tipp: Du musst deinen Benutzernamen und nicht deine Emailadresse nutzen. Achte bitte auf die Groß- und Kleinschreibung.")
                dispatch(loginFailed(error.message));
            }
        );
    };
}

export function loginByToken() {
    return function (dispatch) {
        dispatch(requestLoginByToken());
        return FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.user,
            json => {
                dispatch(loginByTokenSuccessful(json));
            },
            responseNotOk => {
                dispatch(loginByTokenFailed());
            },
            error => {
                dispatch(loginByTokenFailed());
            },
            FetchUtil.LOGIN_BY_TOKEN_TIMEOUT
        );
    };
}

export function logout() {
    return function (dispatch) {
        dispatch(requestLogout());
        return FetchUtil.fetchGet(ConfigUtil.getConfig().logoutUrl,
            json => dispatch(logoutSuccessful()),
            // es gibt keine globale Fehleranzeige (showError existierte nicht), daher nur protokollieren
            responseNotOk => {
                console.error("Logout fehlgeschlagen", responseNotOk.message);
                dispatch(logoutFailed());
            },
            error => {
                console.error("Logout fehlgeschlagen", error);
                dispatch(logoutFailed());
            }
        );
    };
}

